module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/receipt/receipt-grid/receipt-grid.component.css
// module id = ./src/app/finance/receipt/receipt-grid/receipt-grid.component.css
// module chunks = main